import { Schema } from 'mongoose';
import cancellationPolicy, { ICancellationPolicy } from './cancellationPolicy';
import localizedField, { ILocalizedText } from './localized-text';
import mediaField, { IMedia } from './media';
import servicePriceSchema, { ServicePrice } from './service-price';

// export interface IServiceOptionPrice {
//   operator: string;
//   value: number;
// }
// const price = new Schema(
//   {
//     operator: {
//       type: String,
//       enum: ['=', '+', '*'],
//       required: true,
//     },
//     value: {
//       type: Number,
//       required: true,
//     },
//   },
//   { _id: false },
// );

export interface IServiceOptions {
  price: ServicePrice;
  capacity?: number;
  title: ILocalizedText;
  subtitle?: ILocalizedText;
  description?: ILocalizedText;
  media?: IMedia;
  mealType?: ILocalizedText;
  roomType?: ILocalizedText;
  cancellable: boolean;
  cancellationPolicies?: ICancellationPolicy[];
  otherAttributes?: IServiceOptionsOtherAttributes;
  minCapacity?: number;
  maxCapacity?: number;
  startTime?: number;
  endTime?: number;
}
export interface IServiceOptionsOtherAttributes {
  availabilityCode?: {
    type: string;
    source: string;
    code: string;
  };
}
const serviceOptions = new Schema(
  {
    price: {
      type: servicePriceSchema,
      required: true,
    },
    capacity: {
      type: Number,
      required: false,
    },
    title: {
      type: localizedField,
      required: true,
    },
    subtitle: {
      type: localizedField,
    },
    description: {
      type: localizedField,
    },
    media: {
      type: mediaField,
    },
    otherAttributes: {},
    minCapacity: {
      type: Number,
      required: false,
      min: 1,
    },
    maxCapacity: {
      type: Number,
      required: false,
      min: 1,
    },
    startTime: {
      type: Number,
      required: false,
      min: 0,
      max: 23.5,
    },
    endTime: {
      type: Number,
      required: false,
      min: 0,
      max: 23.5,
    },
    mealType: { type: localizedField },
    roomType: { type: localizedField },
    cancellable: {
      type: Boolean,
      required: true,
    },
    cancellationPolicies: { type: [cancellationPolicy] },
  },
  { _id: false },
);

export default serviceOptions;
